export const EPISTEMIC = [
  "Authoritative source",
  "Public technical source",
  "AI extracted — unverified",
  "Human verified",
  "Professional verified",
  "Inferred relationship",
  "Conflicting evidence",
  "Superseded",
  "Unknown / not documented",
  "DEMO / SYNTHETIC",
] as const;

export type EpistemicState = (typeof EPISTEMIC)[number];

export const EXTRACTION = ["Extracted", "Inferred", "Human verified", "Conflicting", "Not documented"] as const;
export type ExtractionState = (typeof EXTRACTION)[number];

export const SOURCE_STATUS = ["LIVE", "MOCK", "REQUIRES_VERIFICATION"] as const;
export type SourceStatus = (typeof SOURCE_STATUS)[number];

export function epistemicClass(state: string): "mock" | "live" | "verify" | "conflict" | "dim" {
  if (state === "DEMO / SYNTHETIC" || state === "MOCK") return "mock";
  if (state === "Conflicting evidence" || state === "Conflicting") return "conflict";
  if (state === "Authoritative source" || state === "Public technical source" || state === "LIVE" || state === "Professional verified" || state === "Human verified")
    return "live";
  if (state === "AI extracted — unverified" || state === "REQUIRES_VERIFICATION") return "verify";
  return "dim";
}
